import { z } from "zod";
import { insolvencySchema } from "@/schemas/users/insolvency";

export const FormalityRequestInsolvencyValidation = z.object({
  can_resolve: z.boolean().optional(),
  has_applicant_insolvencies: z.boolean().optional(),
  has_expedient_insolvencies: z.boolean().optional(),
  applicant_insolvencies: z.array(insolvencySchema).optional(),
  expedient_insolvencies: z.array(insolvencySchema).optional(),
});

export type FormalityRequestInsolvencyType = z.infer<
  typeof FormalityRequestInsolvencyValidation
>;
